export default "assets/images/frizzata_white-1f6f8aaf.png";